import { FC } from 'react';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter';
import { InlineFilter } from 'shared/components/InlineFilter';
import { InlineFilterGroup } from 'shared/components/InlineFilterGroup';
import { selectPriceTypeAvailable } from 'shared/selectors/filters';
import { useSelector } from 'react-redux';
import {
  PriceContainer as PriceFilterContainer,
  PriceTypeContainer,
} from 'shared/containers/AdvancedFiltersContainer/containers/AdvancedFiltersContentContainer/containers/PriceContainer/containers';
import { selectDealType } from 'shared/selectors/jsonQuery';
import { FDealType } from '../../../../../../../packages/JsonQuery';

export const PriceContainer: FC = () => {
  const isPriceTypeAvailable = useSelector(selectPriceTypeAvailable);
  const dealType = useSelector(selectDealType);

  return (
    <AdvancedFilterRow label={dealType === FDealType.RentDaily ? 'Цена за сутки' : 'Цена'}>
      <InlineFilterGroup>
        <InlineFilter width={232}>
          <PriceFilterContainer />
        </InlineFilter>
        {isPriceTypeAvailable && (
          <InlineFilter>
            <PriceTypeContainer />
          </InlineFilter>
        )}
      </InlineFilterGroup>
    </AdvancedFilterRow>
  );
};
